export default {
  'templates.tpl_vars_set_placeholder': 'Set of variables',
  'templates.tpl_type_placeholder': 'Template type',
  'templates.tokens': 'Tokens',
  'templates.tpl_vars_set': 'Set of variables',
  'templates.tpl_type': 'Template type',
  'templates.required_variables': 'Required variables',
  'templates.to_create_template': 'To create a template go here',
  'templates.set_as_default_template': 'Set as default template',
  'templates.this_required': 'This field is required',
  'templates.mjml_tooltip': 'Paste mjml template',
  'templates.is_default': 'Is default',
  'code.snippet': 'Try input @ for autocomplete',
};
